<script setup lang="ts">
import { navaApp } from '~/data/app';

const props = withDefaults(
    defineProps<{
        title: string,
        desc: string,
        mode?: 'default' | 'navaApp'
    }>(),
    { mode: 'default' }
);

const isNavaAppMode = computed(() => props.mode === 'navaApp');

const data = computed(() => {
    if (isNavaAppMode.value) return navaApp;
    return [
        {
            title: 'ورود به پنل مدیریتی',
            url: 'https://cp.navatel.ir/auth/login',
            icon: 'solar:laptop-minimalistic-bold',
        },
        ...navaApp
    ];
});

function setLinkTitle(link: any) {
    if (!link.version || !isNavaAppMode.value) return link.title;
    return `${ link.title } (${ link.version })`;
};

function setBtnType(index: number): TCompTypes {
  const types: TCompTypes[] = ['Primary', 'Outline', 'Thirdly'];
  if (isNavaAppMode.value && index === 4) return 'Outline';
  return types[Math.floor(index / 2)] ?? 'Primary';
};
</script>

<template>
    <SectionsBase id="platform-access" class="container">
        <div 
            class="w-full px-6 lg:px-16 py-8 lg:py-12 flex box
                flex-col lg:flex-row items-center lg:justify-center gap-6 lg:gap-8 rounded-3xl lg:rounded-[48px] 
                mb-15 lg:mb-0"
        >
            <div class="w-full lg:max-w-162.5 order-1 lg:order-2">
                <h2 
                    class="text-white lg:text-start" 
                    :class="isNavaAppMode && 'lg:text-center!'"
                >
                    {{ props.title }}
                </h2>
                <p 
                    class="text-center lg:text-start text-body1 text-primary-50 my-6 lg:my-10" 
                    :class="isNavaAppMode && 'lg:text-center!'"
                >
                    {{ props.desc }}
                </p>
                <div class="grid grid-cols-1 md:grid-cols-2 gap-6 lg:px-10">
                    <Button 
                        v-for="link, index in data"
                        :key="link.title"
                        :type="setBtnType(index)"
                        variant='white'
                        size="Large"
                        :append-icon="{ name: link.icon }"
                        pill
                        :to="link.url"
                        link
                        target="_blank"
                        rel="noopener noreferrer"
                        class="[&_.btn-slot-parent]:w-full"
                        :class="isNavaAppMode && index === 4 && 'lg:col-span-2 lg:mx-auto lg:w-1/2'"
                    >
                        <span class="w-full text-center">{{ setLinkTitle(link) }}</span>
                    </Button>
                </div>
            </div>
            <div class="w-full lg:max-w-110 order-2 lg:order-1 -mb-25 lg:mb-0">
                <NuxtImg 
                    width="500"
                    src="/img/new/laptop-mockup.webp"
                    alt="لپتاپ"
                    class="w-full"
                    loading="lazy"
                />
            </div>
        </div>
    </SectionsBase>
</template>

<style scoped>
.box {
  background: linear-gradient(
    135deg,
    #0140C0 30%,
    #798AFE
  );
  background-size: 200% 200%;
  animation: moveGradient 10s linear infinite alternate;
}

@keyframes moveGradient {
  from {
    background-position: 0% 0%;
  }
  to {
    background-position: 100% 100%;
  }
}
</style>